import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';

const audienceTimelineCss = ":host{position:relative;box-sizing:border-box}:host *,:host *:before,:host *:after{box-sizing:inherit}.audience-timeline{display:flex;flex-direction:row;align-items:center;column-gap:0.5rem;flex-wrap:nowrap;width:min-content}";

const TtAudienceTimeline$1 = /*@__PURE__*/ proxyCustomElement(class extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
  }
  render() {
    return (h("div", { class: "audience-timeline" }, h("slot", null)));
  }
  static get style() { return audienceTimelineCss; }
}, [1, "tt-audience-timeline"]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["tt-audience-timeline"];
  components.forEach(tagName => { switch (tagName) {
    case "tt-audience-timeline":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, TtAudienceTimeline$1);
      }
      break;
  } });
}

const TtAudienceTimeline = TtAudienceTimeline$1;
const defineCustomElement = defineCustomElement$1;

export { TtAudienceTimeline, defineCustomElement };
